<template>
  <SideBarSections bgSection="bg-blue-100">
    <div class="">
      <h2 class="fs-18 lh-24 mb-24 ttc">Design Your Own {{countryName}} Trip</h2>
      <p class="lh-18 fs-14 mb-30">Connect with our Local Designers in <span class='ttc'>{{( countryName) }}</span>, share your trip requirements and they will design the perfect trip, just for you.</p>
      <button @click="submit" class="button button-blue wp-100 maxw-327">
        Start Designing Your Own Trip
      </button>
    </div>
  </SideBarSections>
</template>

<script>
import SideBarSections from '~/components/globals/layout/BodyRightSideBar/SideBarSections'
import { useRoute, useRouter } from 'vue-router'
import { capitalize, publicDomain } from '~/helper'
import { debounceHeapTracking } from '~/mixins/heap'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
export default {
  components: { SideBarSections },
  props:{
    galleryTypes: {
      type: String,
      required: true,
      default: ''
    },
    countryName: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup(props) {
    const domain = publicDomain()
    const router = useRouter()
    const route = useRoute()

    const submit = () => {
      debounceHeapTracking('View Enquiry', {
        source_widget: 'Travel Guide CTA',
        source_type: route.name,
        type: domain === 'agent' ? 'b2b' : 'b2c',
        destination: props.countryName || '',
      })
      debounceAmplitudeScriptTracking('View Enquiry', {
        source_widget: 'Travel Guide CTA',
        source_type: route.name,
        type: domain === 'agent' ? 'b2b' : 'b2c',
        destination: props.countryName || '',
      })
      const url =
        domain === 'agent'
          ? {
              name: 'enquiry-steps',
              params: { galleryTypes: props.galleryTypes, steps: 'trip-details' },
            }
          : {
              name: 'enquiry-submit-destination',
              params: { galleryTypes: props.galleryTypes },
            }
      router.push(url)
    }
    return { submit, capitalize }
  },
}
</script>

<style></style>
